// extracted by mini-css-extract-plugin
export default {"pageRoot":"RecurringConfig_pageRoot__2ZJBb","mainTitle":"RecurringConfig_mainTitle__3S6gC"};